import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import DairyService from '~/api/services/dairy'
import Layout from '~/components/Layout'
import notify from '~/components/Notify'
import { handleErrors, parseDate } from '~/utils/helpers'
import FormWrapper from '../../../Farmers/CreateEditFarmers/FormWrapper'
import ManagerInfo from '../../CreateManager/ManagerInfo'
import LocationForm from '../../CreateManager/LocationForm'
import DairyQuery from '~/QueryHooks/DairyQuery'
import dayjs from 'dayjs'

const ManagerDetails: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [isBusy, setIsBusy] = useState(false)

  const {
    data: managerOptions,
    isLoading: isLoadingOptions,
    refetch: refetchOptions
  } = DairyQuery.getManagersOptions()

  const {
    data: showData,
    isLoading: isLoadingData,
    refetch: fetchData
  } = DairyQuery.editManager(id)

  const {
    data: countries,
    isLoading: isLoadingCountries,
    refetch: fetchCountries
  } = DairyQuery.getCountriesList()

  const methods = useForm({
    mode: 'onChange'
  })

  useEffect(() => {
    if (showData) {
      methods.reset({
        ...showData,
        membershipApplicationDate: showData?.membershipApplicationDate ? dayjs(showData?.membershipApplicationDate).format('DD.MM.YYYY') : '',
        cancellationDate: showData?.cancellationDate ? dayjs(showData?.cancellationDate).format('DD.MM.YYYY') : ''
      })
    }
  }, [showData])

  useEffect(() => {
    refetchOptions()
    fetchData()
    fetchCountries()
  }, [t])

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      if (data.membershipApplicationDate) {
        data.membershipApplicationDate = parseDate(data.membershipApplicationDate)
      }
      if (data.cancellationDate) {
        data.cancellationDate = parseDate(data.cancellationDate)
      }
      await DairyService.updateManager(id, data)
      notify(t('Successfully updated manager'), 'success')
    } catch (errors) {
      handleErrors(errors)
    }
    setIsBusy(false)
  }

  function renderForm() {
    return <>
      <FormWrapper header={t('Manager basic info')}>
        <ManagerInfo
          managerOptions={managerOptions}
          countries={countries || []}
        />
      </FormWrapper>

      <FormWrapper header={t('Location')}>
        <LocationForm countries={countries || []} useGoogleMapLocation />
      </FormWrapper>

    </>
  }

  return <Layout
    useSpinner
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    isBusy={isBusy || isLoadingOptions || isLoadingData || isLoadingCountries}
    title={''}
    onSubmit={methods.handleSubmit(onSubmit)}
    action={t('Update')}
  >

    <FormProvider {...methods}>
      {renderForm()}
    </FormProvider>
  </Layout>
}
export default ManagerDetails